import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../../../core/services/language.service';
import { NgClass } from '@angular/common';

interface Slide {
  title: string;
  date: string;
  desc: string;
  img: string;
  url: string;
  mobileImg?: string;
  endDateTime?: string;
  newTab?: boolean;
}

@Component({
  selector: 'app-event-slider',
  imports: [TranslateModule, NgClass],
  templateUrl: './event-slider.component.html',
  styleUrl: './event-slider.component.scss'
})
export class EventSliderComponent implements OnInit, OnDestroy {
  currentIndex = 0;
  intervalId: any;
  slides: Slide[] = [];
  constructor(private languageService: LanguageService) { }
  // This method is used to handle the on init lifecycle hook
  ngOnInit() {
    this.updateSlidesForLanguage();
    this.startAutoPlay();
  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  // This method is used to start auto play
  startAutoPlay() {
    if (this.slides.length <= 1) {
      return;
    }

    this.stopAutoPlay();
    this.intervalId = setInterval(() => {
      this.next();
    }, 5000); // change every 5s
  }

  stopAutoPlay() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  // This method is used to return to the previous value
  prev() {
    if (!this.slides.length) {
      return;
    }

    this.currentIndex =
      (this.currentIndex - 1 + this.slides.length) % this.slides.length;
  }

  // This method is used to handle the next callback
  next() {
    if (!this.slides.length) {
      return;
    }

    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  goToSlide(index: number) {
    this.currentIndex = index;
    this.startAutoPlay();
  }

  openSlide(slide: Slide) {
    if (!slide?.url) {
      return;
    }
    if (typeof window !== 'undefined') {
      if (slide.newTab) {
        // Correct for user-triggered click events
        window.open(slide.url, '_blank', 'noopener,noreferrer');
      } else {
        // Cleaner & more reliable for same-tab navigation
        window.open(slide.url, '_self', 'noopener');
      }
    }
  }

  private updateSlidesForLanguage() {
    const lang = this.languageService.getCurrentLang() || 'en';
    const imagePath = lang === 'ar' ? '/images/banner/Proud_of_UAE.webp' : '/images/banner/Proud_of_UAE.webp';

    const mobileImagePath = imagePath;
    let url = ''; //`${"https://www.dubaichambers.com/"}${lang}${'/e/dc_event_detail_page/29577/4923535'}?source=cp`;
    const slides: Slide[] = [
      {
        title: 'BG_DASH.EVENT_TITLE',
        date: 'BG_DASH.EVENT_DATE',
        desc: 'BG_DASH.EVENT_DESC',
        img: imagePath,
        url: url,
        mobileImg: mobileImagePath
      },
      {
        title: 'BG_DASH.EVENT_TITLE',
        date: 'BG_DASH.EVENT_DATE',
        desc: 'BG_DASH.EVENT_DESC',
        img: "images/banner/Agentic_AI.webp",
        url: 'https://academy.dubaichambers.com/login/index.php?source=cp',
        mobileImg: "images/banner/Agentic_AI.webp",
        newTab: true
      },
      {
        title: 'BG_DASH.EVENT_TITLE',
        date: 'BG_DASH.EVENT_DATE',
        desc: 'BG_DASH.EVENT_DESC',
        img: "images/banner/Inside_The_Chambers.webp",
        url: 'https://www.dubaichambers.com/en/inside-the-chambers?source=cp',
        mobileImg: "images/banner/Inside_The_Chambers.webp",
        newTab: true
      },
      {
        title: 'BG_DASH.EVENT_TITLE',
        date: 'BG_DASH.EVENT_DATE',
        desc: 'BG_DASH.EVENT_DESC',
        img: "images/banner/COO_Services.webp",
        url: `${window.location.origin}/service-detail/coo`,
        mobileImg: "images/banner/COO_Services.webp",
      },
      {
        title: 'BG_DASH.EVENT_TITLE',
        date: 'BG_DASH.EVENT_DATE',
        desc: 'BG_DASH.EVENT_DESC',
        img: "images/banner/ATA_Carnet.webp",
        url: `${window.location.origin}/service-detail/ata-carnet-registration`,
        mobileImg: "images/banner/ATA_Carnet.webp",
      },
      {
        title: 'BG_DASH.EVENT_TITLE',
        date: 'BG_DASH.EVENT_DATE',
        desc: 'BG_DASH.EVENT_DESC',
        img: "images/banner/Attestation_Services.webp",
        url: `${window.location.origin}/service-detail/attestation-authenticate-document`,
        mobileImg: "images/banner/Attestation_Services.webp",
      },
      {
        title: 'BG_DASH.EVENT_TITLE',
        date: 'BG_DASH.EVENT_DATE',
        desc: 'BG_DASH.EVENT_DESC',
        img: "images/banner/Mediation_Services.webp",
        url: `${window.location.origin}/service-detail/mediation`,
        mobileImg: "images/banner/Mediation_Services.webp",
      }
    ];

    this.slides = this.filterActiveSlides(slides);
    this.currentIndex = this.slides.length ? Math.min(this.currentIndex, this.slides.length - 1) : 0;
  }

  private filterActiveSlides(slides: Slide[]): Slide[] {
    const now = new Date();

    return slides.filter((slide) => {
      if (!slide.endDateTime) {
        return true;
      }

      const endDate = new Date(slide.endDateTime);
      return !Number.isNaN(endDate.getTime()) && endDate >= now;
    });
  }
}
